var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"id":"dmselect","options":_vm.schema.values,"placeholder":_vm.$t('escolhaopcao')},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[[_c('b-form-select-option',{attrs:{"value":undefined,"disabled":""}},[_vm._v("-- "+_vm._s(_vm.$t("escolhaopcao"))+" --")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }